import { colors } from '@insurancemenu/imenu-components-lib';
import NoDataPlaceholder from 'components/common/general/NoDataPlaceholder';
import styled from 'styled-components';

export const RightSectionStyled = styled.div`
  margin: 0 auto;
  padding: 0 2rem 5rem;
  max-width: 92rem;
  min-height: 80%;
  position: relative;
`;

export const NoDataPlaceholderStyled = styled(NoDataPlaceholder)`
  background-color: ${colors.neutral.white};
  border-radius: 1rem;
  box-sizing: border-box;
  padding: 5rem 4rem;
`;
